<!-- Digital Twin Waterway 
Infrastructure Platform -->
<template>
  <div class="dtwin-wateway-intro">
    <div class="wrapper">
      <el-carousel
        indicator-position="inside"
        :loop="true"
        arrow="never"
        :autoplay="true"
        :interval="8000"
        height="382px"
        trigger="click"
        ref="carouse"
        @change="handerChange"
      >
        <el-carousel-item v-for="(item, index) in carouseList" :key="index">
          <aside class="dtwin-wateway-aside">
            <header
              class="aside-hd"
              v-scroll-animate="{
                animation: 'fadeInUp',
              }"
            >
              {{ item.title }}
            </header>
            <p
              class="aside-desc"
              v-scroll-animate="{
                animation: 'fadeInUp',
                delay: 200,
              }"
            >
              {{ item.desc }}
            </p>
            <!-- item.linkUrl -->
            <a class="aside-ft" target="_self" href="javascript:;">
              {{ item.linkLabel }}
            </a>
          </aside>
          <article class="dtwin-wateway-mian">
            <img class="c_img cursor-pointer" :src="item.picUrl" alt="轮播图" />
          </article>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: "TwinWaterwayIntro",
  components: {},
  data() {
    return {
      currentPage: 1,
      carouseList: [
        {
          id: 1,
          picUrl: require("@/assets/images/dtwin/twin-wateway-1.png"),
          title: "Digital Twin Waterway Infrastructure Platform",
          desc: "The Digital Twin Waterway Infrastructure Platform recreates models of waterway sections, locks, embankments, bridges, riverbeds, and more, integrating data and simulating twin models. This platform provides a more intuitive and visual management approach for waterway operation management and status monitoring, enhancing the intelligence level of waterway management and services.",
          linkUrl: "",
          linkLabel: "Waterway Operation Monitoring Visualization　>",
        },
        {
          id: 2,
          picUrl: require("@/assets/images/dtwin/twin-wateway-2.png"),
          title: "Digital Twin Waterway Infrastructure Platform",
          desc: "Using high-precision sensors and 3D modeling technology, the platform accurately maps, models, and dynamically links key data such as riverbed terrain, bottom quality, and erosion and sedimentation areas. Real-time collection of riverbed depth changes and sediment distribution is presented directly on the twin model, offering comprehensive, all-time visual monitoring of the riverbed's status.",
          linkUrl: "",
          linkLabel: "Riverbed Monitoring Visualization　>",
        },
        {
          id: 3,
          picUrl: require("@/assets/images/dtwin/twin-wateway-3.png"),
          title: "Digital Twin Waterway Infrastructure Platform",
          desc: "Advanced digital collection technologies are applied to comprehensively gather data and build models for facilities along the waterway, such as beacons, lighthouses, navigation aids, and communication stations. Through IoT technology, real-time status data of these facilities is seamlessly integrated with the digital model. Whether it's facility location information, operational parameters, or operational status, all are accurately displayed in the digital twin model.",
          linkUrl: "",
          linkLabel: "Waterway Facility Visualization　>",
        },
      ],
    };
  },
  computed: {},
  created() {
    console.log("this.carouseList--11", this.carouseList);
  },
  mounted() {},
  methods: {
    handerChange(index) {
      this.currentPage = index + 1;
    },
    handleCurrentChange({ pageIndex }) {
      console.log(`当前页: ${pageIndex}`);
      this.currentPage = pageIndex;
      this.$refs.carouse.setActiveItem(this.currentPage - 1);
    },
  },
};
</script>

<style lang="scss">
.dtwin-wateway-intro {
  width: 100%;
  background: url("~@/assets/images/dtwin/twin-wateway_bg.png") no-repeat center;
  background-size: 100% 564px;
  background-size: cover;
  padding: 80px 0;
  .wrapper {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    height: 382px;

    .dtwin-wateway-aside {
      position: relative;
      flex: 1;
      min-width: 400px;
      margin-right: 40px;
      .aside-hd {
        margin-bottom: 32px;
        width: 280px;
        font-weight: bold;
        font-size: 24px;
        color: #ffffff;
        line-height: 32px;
        text-align: left;
        font-style: normal;
      }
      .aside-desc {
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 24px;
        text-align: justify;
        font-style: normal;
      }
      .aside-ft {
        position: absolute;
        left: 0;
        bottom: 22px;
        font-weight: 400;
        font-size: 18px;
        color: #bae8fa;
        line-height: 27px;
        text-align: left;
        font-style: normal;
        cursor: default;
        &:hover {
          // opacity: 0.8;
          // text-decoration: underline;
        }
      }
    }
    .dtwin-wateway-mian {
      width: 740px;
      height: 100%;
      img {
        width: 100%;
        height: 360px;
        object-fit: cover;
        box-shadow: 0px 2px 25px 0px rgba(0, 0, 0, 0.5);
      }
    }

    .el-carousel__item {
      display: flex;
      height: 100%;
    }
    .el-carousel__indicators {
      left: 70%;

      .el-carousel__indicator--horizontal {
        padding: 10px 4px 0 4px;
        margin-right: 8px;
        .el-carousel__button {
          width: 24px;
          height: 4px;
          border-radius: 2px;
          transition: all 0.3s;
        }
        &.is-active {
          .el-carousel__button {
            width: 80px;
            background-color: #1fabab;
          }
        }
      }
    }
  }
}
</style>
